import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { encodeUrl } from "../../utils/urlHelper";

class SearchOptions extends React.Component {
  componentDidMount() {
    this.redirectToFirstMenuItem();
  }

  redirectToFirstMenuItem = () => {
    const { uiData } = this.props;
    const leftMenus = [];
    _.forEach(uiData.Menus.MenuItems, (f) => {
      if (f.MenuLevel === 3) leftMenus.push(f);
    });
    const orderedLeftMenus = _.orderBy(leftMenus, ["MenuId"], ["asc"]);
    const leftMenu = orderedLeftMenus[0];
    if (leftMenu === undefined) {
      this.setState({
        searchLoadError: "Menu items are empty",
      });
      return;
    }
    const subMenu = _.find(
      uiData.Menus.MenuItems,
      (a) => a.MenuId === leftMenu.ParentId
    );
    if (subMenu === undefined) {
      this.setState({
        searchLoadError: "The selected page not found",
      });
      return;
    }
    const mainMenu = _.find(
      uiData.Menus.MenuItems,
      (a) => a.MenuId === subMenu.ParentId
    );
    if (mainMenu === undefined) {
      this.setState({
        searchLoadError: "The selected page not found",
      });
      return;
    }
    this.props.history.push(
      `/search/${encodeUrl(mainMenu.MenuTitle)}/${encodeUrl(
        subMenu.MenuTitle
      )}/${encodeUrl(leftMenu.MenuTitle)}/${leftMenu.MenuId}`
    );
  };

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, null)(SearchOptions);



// WEBPACK FOOTER //
// ./src/components/pages/SearchOptions.js